import { Button, Form, Input } from 'antd';
import { Select } from 'antd/lib';
import { eSignContractMutualFundStatusOptions } from 'apps/investment/constants/fund-econtrac';
import { formItemLayout, tailFormItemLayout } from 'utils/formConfig';

const ItemForm = ({ form, submiting, onFinish, initialValues, name }) => {
  return (
    <Form
      {...formItemLayout}
      form={form}
      name={name || 'form'}
      onFinish={values => onFinish(values)}
      initialValues={initialValues}
      scrollToFirstError
    >
      <Form.Item name="contract_id" label="Contract ID">
        <Input placeholder="" />
      </Form.Item>
      <Form.Item name="contract_number" label="Contract Number">
        <Input placeholder="" />
      </Form.Item>
      <Form.Item name="status" label="Status">
        <Select
          className="w-full"
          options={eSignContractMutualFundStatusOptions}
        />
      </Form.Item>

      <Form.Item {...tailFormItemLayout}>
        <Button type="primary" htmlType="submit" loading={submiting}>
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ItemForm;
